export { ProductReviewCardDs, ProductReviewCardDsFooter } from './product-review-card-ds'
export type { ProductReviewCardDsProps, ProductReviewCardDsFooterProps } from './product-review-card-ds'
